import {
    Box,
    Button,
    CardContent,
    Checkbox,
    Chip,
    Container,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
    CheckBoxLabel,
    DocumentLabels,
    SelectSpan,
    StyledCard,
    StyledOutlineButton,
    VendorCardLabel,
} from "../StepMain";
import { useSelector, useDispatch } from "react-redux";
import { Super } from "./cardTrial";
import {
    VendorCardTitle,
    VendorListHolder,
} from "./vendorReg";

import { styled as materialStyles } from "@mui/material/styles";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
    addbank,
    editbank,
    getBanks,
    getBanksIdWise,
    getCountries,
    getStates,
    getCurrencies,
    validatebank,
} from "../../../bankDetails/redux/bankDetailsSlice";
import { history } from "../../../../app/history";
import LocalStorage from "../../../../utilities/localStorage";
import { bank_info, IFSC_REGEX } from "../../../../utilities/helper";
import { ExpandMore } from "@mui/icons-material";
import { message } from "antd";

const Input = materialStyles("input")({
    display: "none",
});

function BankDetailsEdit({
    vendor_id,
    vendor_user_id,
    handleBack,
    is_domestic,
    company_id,
    bankId,
    onSuccess,
    onCancel,
    isLocked,
}) {
    const [loading, setLoading] = useState(false);
    const { countries, states, currencies, getBanksDetails, bank } = useSelector(
        (state) => state.bankdetails
    );
    const [bankInfo, setBankInfo] = useState({});
    const [bankInfoId, setBankInfoId] = useState(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        setValue,
        reset,
    } = useForm();

    const dispatch = useDispatch();
    const user = LocalStorage.getItem("tata_login_user");
    const primary_role = user.roles[0];

    const [checkedPrimary, setCheckedPrimary] = useState(false);
    const [supportingDoc, setSupportingDoc] = useState("");
    const [rtgsDoc, setRtgsDoc] = useState("");
    const [cancelledCheque, setCancelledCheque] = useState("");
    const [bankStatement, setBankStatment] = useState("");
    const [passBook, setPassBook] = useState("");
    const [ifscCode, setIfscCode] = useState("");
    const [showBankDetails, setShowBankDetails] = useState(false);
    const [disabled, setDisabled] = useState(is_domestic ? true : false);
    const [disableEditBtn, setDisableEditBtn] = useState(false);

    const watchFields = watch(["rtgs", "bankStatement", "ca"]);

    const populateData = (response) => {
        setBankInfoId(response.id);

        const updatedBankInfo = {
            account_name: response?.account_name,
            account_number: response?.account_number,
            address_line_one: response?.address_line_one,
            bank_name: response?.bank_name,
            branch_name: response?.branch_name,
            city: response?.city,
            currency: response?.currency,
            country: response?.country,
            ifsc_code: response?.ifsc_code,
            swift_code: response?.swift_code,
            is_primary_account: response?.is_primary_account,
            state: response?.state,
        };

        setBankInfo(updatedBankInfo);
        setIfscCode(response?.ifsc_code);
        setCheckedPrimary(response?.is_primary_account === 1 || response?.is_primary_account === true);
        setShowBankDetails(true);
        setDisabled(false);
        reset(updatedBankInfo);
        // Sync the IFSC field with react-hook-form so validation doesn't
        // show "Please enter IFSC" on a pre-populated edit screen
        setValue("ifsc", response?.ifsc_code || "");

        if (response?.country) {
            dispatch(getStates(Number(response.country)));
        }

        if (response?.Bank_Documents?.length > 0) {
            const docs = response.Bank_Documents[0];
            if (docs.bank_statement_image_name) {
                setBankStatment({
                    name: docs.bank_statement_image_name,
                    image: docs.bank_statement_image,
                });
            }
            if (docs.cancelled_cheque_image_name) {
                setCancelledCheque({
                    name: docs.cancelled_cheque_image_name,
                    image: docs.cancelled_cheque_image,
                });
            }
            if (docs.rtgs_authorization_letter_image_name) {
                setRtgsDoc({
                    name: docs.rtgs_authorization_letter_image_name,
                    image: docs.rtgs_authorization_letter_image,
                });
            }
            if (docs.bank_passbook_copy_with_bank_stamp_image_name) {
                setPassBook({
                    name: docs.bank_passbook_copy_with_bank_stamp_image_name,
                    image: docs.bank_passbook_copy_with_bank_stamp_image,
                });
            }
            if (docs.supporting_document_image_name) {
                setSupportingDoc({
                    name: docs.supporting_document_image_name,
                    image: docs.supporting_document_image,
                });
            }
        }
    };

    useEffect(() => {
        dispatch(getCountries());
        dispatch(getCurrencies());
        if (bankId) {
            // Use id-wise endpoint which includes Bank_Documents in response
            dispatch(getBanksIdWise(bankId)).then((data) => {
                if (data.payload?.success) {
                    populateData(data.payload.data[0]);
                }
            });
        }
    }, [bankId, dispatch, reset]);

    const handleChangecountry = (payload) => {
        dispatch(getStates(payload));
    };

    const handleChange = (event) => {
        setCheckedPrimary(event.target.checked);
    };

    const handleIfscChange = (value) => {
        if (isLocked) return;
        const capsValue = value.toUpperCase();
        setIfscCode(capsValue);
        setValue("ifsc", capsValue, { shouldValidate: true });
        setDisableEditBtn(true);
        setDisabled(true); // Require re-validation if IFSC changes
        setShowBankDetails(false); // Hide old bank details when IFSC changes
    };

    const validateBank = () => {
        dispatch(validatebank({ ifsc: ifscCode })).then((response) => {
            if (response.payload.success) {
                setDisabled(false);
                setShowBankDetails(true);
                const { data } = response.payload;
                setBankInfo({
                    ...bankInfo,
                    address_line_one: data?.address,
                    bank_name: data?.bank,
                    branch_name: data?.branch,
                    swift_code: data?.swiftCode,
                    city: data?.city,
                    state: data?.state,
                });
            }
        });
    };

    const onInputChange = (e) => {
        if (isLocked) return;
        const { name, value } = e.target;
        if (name === "country") {
            setBankInfo((prev) => ({ ...prev, state: "", country: value }));
            setValue("state", "", { shouldValidate: true });
            handleChangecountry(value);
        }
        setBankInfo({
            ...bankInfo,
            [name]: value,
        });
    };

    const handleNext = (data) => {
        if (bank_info) {
            if (rtgsDoc === "" && cancelledCheque === "" && bankStatement === "") {
                return message.error("At least one document is required in mandatory fields");
            }
        }

        if (!is_domestic && states.some((item) => item?.StateName === bankInfo.state) === false) {
            return message.error("Please select a valid state");
        }

        var formData = new FormData();
        setLoading(true);

        const submitData = {
            ...data,
            user_id: primary_role === "officer" ? vendor_user_id : user.id,
            company_id: company_id || user.company_id,
            vendor_id: vendor_id
        };

        if (bankInfoId) {
            submitData.bankInfoId = bankInfoId;
        }

        formData.append("data", JSON.stringify(submitData));
        formData.append("account_name", bankInfo.account_name);
        formData.append("account_number", bankInfo.account_number);
        formData.append("rtgs_authorization_letter_image", rtgsDoc);
        formData.append("cancelled_cheque_image", cancelledCheque);
        formData.append("bank_statement_image", bankStatement);
        formData.append("bank_passbook_copy_with_bank_stamp_image", passBook);
        formData.append("supporting_document_image", supportingDoc);
        formData.append("is_primary_account", checkedPrimary);

        if (is_domestic) {
            formData.append("ifsc", ifscCode);
            formData.append("address_line_one", bankInfo.address_line_one);
            formData.append("branch_name", bankInfo.branch_name);
            formData.append("bank_name", bankInfo.bank_name);
            formData.append("countryCode", "IN");
            formData.append("city", bankInfo.city);
            formData.append("state", bankInfo.state);
            formData.append("swift_code", bankInfo.swift_code || bankInfo.swiftCode || "");
        } else {
            formData.append("swift_code", bankInfo.swift_code);
            formData.append("branch_name", bankInfo.branch_name);
            formData.append("bank_name", bankInfo.bank_name);
            formData.append("countryCode", bankInfo.country);
            formData.append("city", bankInfo.city);
            formData.append("state", bankInfo.state);
            formData.append("currency", bankInfo.currency);
        }

        const action = bankInfoId ? editbank(formData) : addbank(formData);

        dispatch(action).then((response) => {
            setLoading(false);
            if (response?.payload?.success) {
                if (onSuccess) {
                    onSuccess();
                } else if (primary_role === "user") {
                    history.push("/app");
                }
            }
        });
    };

    const payment_info_officer = (
        <CardContent>
            <Container fixed>
                <Grid>
                    <VendorCardTitle>Payment Information</VendorCardTitle>
                </Grid>
                <VendorListHolder>
                    <li>Enter account name, account number, and IFSC Code to validate bank details.</li>
                    <li>Bank details will be auto-populated once bank is validated.</li>
                    <li>Proceed to add supporting documents of bank once bank is validated.</li>
                </VendorListHolder>
                <br />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                        <VendorCardLabel>
                            Account holder name <Super>*</Super>
                        </VendorCardLabel>
                        <TextField
                            sx={{ input: { fontSize: "14px", fontFamily: "var(--font-family-reg)" } }}
                            variant="standard"
                            style={{ width: "100%", paddingTop: "3px" }}
                            name="account_name"
                            {...register("account_name", { required: "Please enter account name" })}
                            error={Boolean(errors?.account_name)}
                            helperText={errors.account_name?.message}
                            value={bankInfo?.account_name ?? ""}
                            onChange={onInputChange}
                            disabled={isLocked}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <VendorCardLabel>
                            {is_domestic ? "Account Number" : "IBAN Number"}
                            <Super>*</Super>
                        </VendorCardLabel>
                        <TextField
                            sx={{ input: { fontSize: "14px", fontFamily: "var(--font-family-reg)", textTransform: is_domestic ? "none" : "uppercase" } }}
                            variant="standard"
                            style={{ width: "100%", paddingTop: "3px" }}
                            name="account_number"
                            {...register("account_number", is_domestic
                                ? {
                                    required: "Please enter account number",
                                    pattern: { value: /^\d+$/, message: "Only digits allowed for account number" },
                                    maxLength: { value: 18, message: "Maximum 18 digits allowed" }
                                }
                                : {
                                    required: "Please enter IBAN number",
                                    pattern: { value: /^[A-Z0-9]+$/i, message: "Invalid IBAN number" }
                                }
                            )}
                            error={Boolean(errors?.account_number)}
                            helperText={errors.account_number?.message}
                            value={bankInfo?.account_number ?? ""}
                            inputProps={{ maxLength: is_domestic ? 18 : undefined }}
                            onChange={(e) => {
                                if (is_domestic) {
                                    e.target.value = e.target.value.replace(/\D/g, "");
                                } else {
                                    e.target.value = e.target.value.toUpperCase();
                                }
                                onInputChange(e);
                            }}
                            disabled={isLocked}
                        />
                    </Grid>
                </Grid>
                <br />
                <Grid container spacing={2}>
                    {is_domestic && (
                        <>
                            <Grid item xs={12} sm={6} md={6}>
                                <VendorCardLabel>
                                    IFSC Code <Super>*</Super>
                                </VendorCardLabel>
                                <TextField
                                    sx={{ input: { fontSize: "14px", fontFamily: "var(--font-family-reg)", textTransform: "uppercase" } }}
                                    variant="standard"
                                    style={{ width: "100%", paddingTop: "3px" }}
                                    name="ifsc"
                                    {...register("ifsc", {
                                        pattern: { value: IFSC_REGEX, message: "Invalid IFSC Code" },
                                        required: "Please enter IFSC",
                                    })}
                                    onChange={(e) => handleIfscChange(e.target.value)}
                                    error={Boolean(errors?.ifsc)}
                                    value={ifscCode ?? ""}
                                    helperText={errors.ifsc?.message}
                                    disabled={isLocked}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <Button variant="contained" sx={{ width: "150px", marginTop: "10px" }} onClick={validateBank} disabled={isLocked}>
                                    Validate IFSC
                                </Button>
                            </Grid>
                        </>
                    )}
                </Grid>
                <br />
                {(showBankDetails || bankInfoId) && (
                    <Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                                <VendorCardLabel>Bank Name<Super>*</Super></VendorCardLabel>
                                <span><b>{bankInfo.bank_name}</b></span>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <VendorCardLabel>Branch Name<Super>*</Super></VendorCardLabel>
                                <span><b>{bankInfo?.branch_name}</b></span>
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                                <VendorCardLabel>Address line 1<Super>*</Super></VendorCardLabel>
                                <span><b>{bankInfo?.address_line_one}</b></span>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {!is_domestic && (
                    <Grid>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={4}>
                                <VendorCardLabel>Bank name<Super>*</Super></VendorCardLabel>
                                <TextField
                                    sx={{ input: { fontSize: "14px", fontFamily: "var(--font-family-reg)" } }}
                                    variant="standard"
                                    style={{ width: "100%", paddingTop: "3px" }}
                                    name="bank_name"
                                    {...register("bank_name", { required: "Please enter bank name" })}
                                    error={Boolean(errors?.bank_name)}
                                    helperText={errors.bank_name?.message}
                                    value={bankInfo?.bank_name}
                                    onChange={onInputChange}
                                    disabled={isLocked}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <VendorCardLabel>Branch name<Super>*</Super></VendorCardLabel>
                                <TextField
                                    sx={{ input: { fontSize: "14px", fontFamily: "var(--font-family-reg)" } }}
                                    variant="standard"
                                    style={{ width: "100%", paddingTop: "3px" }}
                                    name="branch_name"
                                    {...register("branch_name", { required: "Please enter branch name" })}
                                    error={Boolean(errors?.branch_name)}
                                    helperText={errors.branch_name?.message}
                                    value={bankInfo?.branch_name ?? ""}
                                    onChange={onInputChange}
                                    disabled={isLocked}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <VendorCardLabel>Swift code</VendorCardLabel>
                                <TextField
                                    sx={{ input: { fontSize: "14px", fontFamily: "var(--font-family-reg)" } }}
                                    variant="standard"
                                    style={{ width: "100%", paddingTop: "3px" }}
                                    name="swift_code"
                                    {...register("swift_code")}
                                    value={bankInfo?.swift_code ?? ""}
                                    onChange={onInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl variant="standard" style={{ width: "100%" }} error={Boolean(errors?.country)}>
                                    <VendorCardLabel>Country<Super>*</Super></VendorCardLabel>
                                    <Select
                                        displayEmpty
                                        IconComponent={() => <ExpandMore style={{ color: "#A5A5BA" }} />}
                                        {...register("country", { required: "Please select country" })}
                                        onChange={onInputChange}
                                        value={bankInfo?.country ?? ""}
                                    >
                                        <MenuItem value=""><span style={{ fontSize: "14px", color: "#A5A5BA" }}>Select country</span></MenuItem>
                                        {countries.map((item, index) => (
                                            <MenuItem value={item.id} key={index}><SelectSpan>{item.CountryName}</SelectSpan></MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{errors.country?.message}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl variant="standard" style={{ width: "100%" }} error={Boolean(errors?.state)}>
                                    <VendorCardLabel>State<Super> *</Super></VendorCardLabel>
                                    <Select
                                        displayEmpty
                                        IconComponent={() => <ExpandMore style={{ color: "lightgray" }} />}
                                        {...register("state", { required: "Please select state" })}
                                        value={bankInfo?.state || ""}
                                        onChange={onInputChange}
                                    >
                                        <MenuItem value=""><span style={{ fontSize: "14px", color: "lightgray" }}>Select state</span></MenuItem>
                                        {states.map((item, index) => (
                                            <MenuItem value={item.StateName} key={index}><SelectSpan>{item.StateName}</SelectSpan></MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{errors.state?.message}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <VendorCardLabel>City<Super>*</Super></VendorCardLabel>
                                <TextField
                                    sx={{ input: { fontSize: "14px", fontFamily: "var(--font-family-reg)" } }}
                                    variant="standard"
                                    name="city"
                                    style={{ width: "100%", paddingTop: "3px" }}
                                    {...register("city", { required: "Please enter city" })}
                                    error={Boolean(errors?.city)}
                                    helperText={errors.city?.message}
                                    value={bankInfo?.city ?? ""}
                                    onChange={onInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl variant="standard" style={{ width: "100%" }} error={Boolean(errors?.currency)}>
                                    <VendorCardLabel>Currency<Super> *</Super></VendorCardLabel>
                                    <Select
                                        displayEmpty
                                        IconComponent={() => <ExpandMore style={{ color: "lightgray" }} />}
                                        {...register("currency", { required: "Please select currency" })}
                                        value={bankInfo?.currency || ""}
                                        onChange={onInputChange}
                                    >
                                        <MenuItem value=""><span style={{ fontSize: "14px", color: "lightgray" }}>Select Currency</span></MenuItem>
                                        {currencies.map((item, index) => (
                                            <MenuItem value={item.CurrencyName} key={index}><SelectSpan>{item.CurrencyName}</SelectSpan></MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{errors.currency?.message}</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Container>
        </CardContent>
    );

    const documents = (
        <CardContent>
            <Container fixed>
                <Grid container spacing={2}>
                    <Grid item xs={12}><VendorCardTitle>Supporting Documents</VendorCardTitle></Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}><DocumentLabels>Upload cancelled cheque <Super>*</Super></DocumentLabels></Grid>
                    <Grid item xs={6}>
                        <FormControl variant="standard" style={{ width: "100%" }} error={Boolean(errors?.cancelledCheque)}>
                            {cancelledCheque ? (
                                <span>
                                    <Chip sx={{ width: "150px" }} label={cancelledCheque.name} />
                                    <HighlightOffIcon onClick={() => setCancelledCheque("")} />
                                </span>
                            ) : (
                                <label htmlFor="cancelledCheque">
                                    <Input accept="*" id="cancelledCheque" type="file" onChange={(e) => setCancelledCheque(e.target.files[0])} disabled={isLocked} />
                                    <StyledOutlineButton variant="outlined" component="span" disabled={isLocked}>Upload</StyledOutlineButton>
                                </label>
                            )}
                            {errors.cancelledCheque && <FormHelperText>{errors.cancelledCheque.message}</FormHelperText>}
                        </FormControl>
                    </Grid>
                </Grid>
                <br />
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}><DocumentLabels>Bank Mandate duly stamped <Super>*</Super></DocumentLabels></Grid>
                    <Grid item xs={6}>
                        <FormControl variant="standard" style={{ width: "100%" }}>
                            {rtgsDoc ? (
                                <span>
                                    <Chip sx={{ width: "150px" }} label={rtgsDoc.name} />
                                    <HighlightOffIcon onClick={() => setRtgsDoc("")} />
                                </span>
                            ) : (
                                <label htmlFor="rtgs">
                                    <Input accept="*" id="rtgs" type="file" onChange={(e) => setRtgsDoc(e.target.files[0])} disabled={isLocked} />
                                    <StyledOutlineButton variant="outlined" component="span" disabled={isLocked}>Upload</StyledOutlineButton>
                                </label>
                            )}
                        </FormControl>
                    </Grid>
                </Grid>
                <br />
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}><DocumentLabels>Upload bank statement <Super>*</Super></DocumentLabels></Grid>
                    <Grid item xs={6}>
                        <FormControl variant="standard" style={{ width: "100%" }}>
                            {bankStatement ? (
                                <span>
                                    <Chip sx={{ width: "150px" }} label={bankStatement.name} />
                                    <HighlightOffIcon onClick={() => setBankStatment("")} />
                                </span>
                            ) : (
                                <label htmlFor="bankStatement">
                                    <Input accept="*" id="bankStatement" type="file" onChange={(e) => setBankStatment(e.target.files[0])} disabled={isLocked} />
                                    <StyledOutlineButton variant="outlined" component="span" disabled={isLocked}>Upload</StyledOutlineButton>
                                </label>
                            )}
                        </FormControl>
                    </Grid>
                </Grid>
                <br />
                <FormControlLabel
                    control={<Checkbox checked={checkedPrimary} onChange={handleChange} />}
                    label={<CheckBoxLabel>Make this my primary bank account</CheckBoxLabel>}
                />
            </Container>
        </CardContent>
    );

    return (
        <div>
            <form onSubmit={handleSubmit(handleNext)}>
                <StyledCard>{payment_info_officer}</StyledCard>
                <StyledCard>{documents}</StyledCard>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2, justifyContent: "space-between" }}>
                    <Button color="inherit" onClick={onCancel || handleBack} sx={{ mr: 1 }}>{onCancel ? "Cancel" : "Back"}</Button>
                    <LoadingButton
                        sx={{ textTransform: "none", background: "var(--button-color)", width: "200px" }}
                        color="success"
                        variant="contained"
                        type="submit"
                        disabled={(bankInfoId && !disableEditBtn ? false : disabled) || isLocked}
                        loading={loading}
                    >
                        {isLocked ? "Submitted" : (bankInfoId ? "Update & Finish" : "Save & Finish")}
                    </LoadingButton>
                </Box>
            </form>
        </div>
    );
}

export default BankDetailsEdit;
